// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iYCn","col":"styles_col__3wE4A"};